// hooks/useSetup.ts — setup-gate status (is Key1 configured?) (spec §4.4).
import { useCallback, useEffect, useState } from 'react';
import { useServices } from '../app/AppContext';
import type { SetupStatus } from '../lib/api';

export interface UseSetup {
  status: SetupStatus | null;
  loading: boolean;
  error: string | null;
  refresh: () => Promise<void>;
}

export function useSetup(): UseSetup {
  const { api } = useServices();
  const [status, setStatus] = useState<SetupStatus | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      setStatus(await api.getSetupStatus());
      setError(null);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Failed to load setup status');
    } finally {
      setLoading(false);
    }
  }, [api]);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { status, loading, error, refresh };
}
